import React from 'react';
import {DataType, Mutation, Query} from "./ApiProvider/types";

export type CachePolicy  = "network-first" | "no-cache";


export interface IApiContext {
    fetchQuery<T>(query: Query<T>, cachePolicy?: CachePolicy): Promise<DataType<T>>;
    mutate<T, D>(mutation: Mutation<T>, data: D): Promise<DataType<T>>;
}

// @ts-ignore
export const ApiContext = React.createContext<IApiContext>();